import { takeEvery, put, call } from "redux-saga/effects";

import {
  getOrdersAPI,
  getOrderAPI,
  getOrderHistoryAPI,
} from "../../helpers/backend.helper";
import { GET_ORDERS, GET_ORDER, GET_ORDER_HISTORY } from "./actionTypes";
import {
  getOrderError,
  getOrderHistoryError,
  getOrderHistorySuccess,
  getOrdersError,
  getOrdersSuccess,
  getOrderSuccess,
} from "./actions";

function* getOrders({ payload: { request } }) {
  try {
    const response = yield call(getOrdersAPI, request);
    if (response) {
      yield put(getOrdersSuccess(response?.data));
    }
  } catch (error) {
    yield put(getOrdersError(error));
  }
}

function* getOrder({ payload: { id } }) {
  try {
    const response = yield call(getOrderAPI, id);
    if (response) {
      yield put(getOrderSuccess(response?.data));
    }
  } catch (error) {
    yield put(getOrderError(error));
  }
}

function* getOrderHistory({ payload: { id } }) {
  try {
    const response = yield call(getOrderHistoryAPI, id);
    if (response) {
      yield put(getOrderHistorySuccess(response?.data));
    }
  } catch (error) {
    yield put(getOrderHistoryError(error));
  }
}

function* ordersSaga() {
  yield takeEvery(GET_ORDERS, getOrders);
  yield takeEvery(GET_ORDER, getOrder);
  yield takeEvery(GET_ORDER_HISTORY, getOrderHistory);
}

export default ordersSaga;
